// Border colour for a form field: green = good, yellow = check it, red = fix it.
// Uses outline so the embossed inset shadow on inputs stays intact.
export type FieldTone = 'idle' | 'ok' | 'warn' | 'error';

const TONES: Record<FieldTone, string> = {
  idle: '',
  ok: 'outline outline-1 -outline-offset-1 outline-[hsl(var(--success))]',
  warn: 'outline outline-1 -outline-offset-1 outline-[hsl(var(--warning))]',
  error: 'outline outline-1 -outline-offset-1 outline-destructive',
};

export const fieldTone = (tone: FieldTone) => TONES[tone];
